import useFeature, { FeatureFlag } from 'hooks/useFeature';

export const DEFAULT_ORGANIZATION_LEADER_TERMS_URL =
  'https://www.schools.campuslush.com/l/campuslush-student-organization-leader-code-of-conduct';

export interface SchoolTerms {
  termsUrl?: string;
  termsDisplayName?: string;
}

export interface OrganizationLeaderTermsConfig {
  termsUrl: string;
  termsDisplayText: string;
  checkboxText: string;
}

/**
 * Get organization leader terms configuration based on school terms and feature flag
 */
export const useOrganizationLeaderTerms = (
  schoolTerms?: SchoolTerms,
): OrganizationLeaderTermsConfig => {
  const organisationLeaderInviteFlowEnabled = useFeature(
    FeatureFlag.OrganisationLeaderInviteFlow,
  );

  const hasSchoolTerms =
    organisationLeaderInviteFlowEnabled &&
    schoolTerms?.termsUrl &&
    schoolTerms?.termsDisplayName &&
    schoolTerms.termsUrl.trim() !== '' &&
    schoolTerms.termsDisplayName.trim() !== '';

  const termsUrl = hasSchoolTerms ? schoolTerms.termsUrl : DEFAULT_ORGANIZATION_LEADER_TERMS_URL;
  const termsDisplayText = hasSchoolTerms
    ? schoolTerms.termsDisplayName
    : 'CampusLush Code of Conduct';
  const checkboxText = hasSchoolTerms
    ? 'I have read and agree to the university\'s terms.'
    : 'I have read and agree to the code of conduct.';

  return {
    termsUrl: termsUrl || DEFAULT_ORGANIZATION_LEADER_TERMS_URL,
    termsDisplayText: termsDisplayText || 'CampusLush Code of Conduct',
    checkboxText,
  };
};
